import {
  UT_LIST,
  CREATE_FD_RESULT,
  GET_VIEW_FD,
  GET_CLAIM_DATA, BACK_TO_MODIFICATION,
  VERIFY_INVOICE_NUMBERS,
  EDIT_CLIENT_DETAILS
} from "./type";

const initalState = {
  unclaimedTransLists: {},
  createFdResult:{},
  fdTicketDetails:{},
  getClaimData:{},
  backToModificationRequest:[],
  verifyInvoiceNumbersWithRecon: {},
  editClientDetailsForTan: {}
};

const UnclaimedTranxReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UT_LIST:
      return {
        ...state,
        unclaimedTransLists: payload,
      };
    case CREATE_FD_RESULT:
      return {
        ...state,
        createFdResult: payload,
      };
    case GET_VIEW_FD:
      return {
        ...state,
        fdTicketDetails: payload,
      };
    case GET_CLAIM_DATA:
      return {
        ...state,
        getClaimData: payload
      }
    case BACK_TO_MODIFICATION:
      return {
        ...state,
        backToModificationRequest: payload
      }
      case VERIFY_INVOICE_NUMBERS:
      return {
        ...state,
        verifyInvoiceNumbersWithRecon: payload
      }
    case EDIT_CLIENT_DETAILS:
      return {
        ...state,
        editClientDetailsForTan: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default UnclaimedTranxReducer;
